import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse, SpiritoryWebEndpoints } from '@/types/api/api-v2';
import { BlogPost } from '@/types/Blog';
import { getValidLocale } from '@/utilites/language/language.utils';

export default async function getBlogPosts(
  query?: string,
  locale: string = 'en'
): Promise<BlogPost[]> {
  try {
    const validLocale = getValidLocale(locale);
    const encodedQuery = encodeURIComponent(query?.trim() || '');
    const finalURL = `/blog?query=${encodedQuery}&locale=${validLocale}`;
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<BlogPost[]>>(finalURL as SpiritoryWebEndpoints);
    return data;
  } catch (e) {
    throw e;
  }
}
